import {useContext} from "react";
import {About, AboutContext} from "./About";
import InformationCard from "./index";
import LegendCard from "../esri-components/LegendCard";

export const Info = () => {
    const {showAbout, toggleAboutModal} = useContext(AboutContext);
    return (
        <>
            <InformationCard
                position="top-0 right-0"
                customClass="h-auto w-auto"
            />
            <LegendCard
                position="bottom-0 left-0"
                customClass="h-auto w-auto"
            />
            {showAbout && <About onClose={toggleAboutModal}/>}
        </>
    );
};